import { render, staticRenderFns } from "./EmbedPage.vue?vue&type=template&id=2fd2e5e4&scoped=true"
import script from "./EmbedPage.vue?vue&type=script&lang=js"
export * from "./EmbedPage.vue?vue&type=script&lang=js"
import style0 from "./EmbedPage.vue?vue&type=style&index=0&id=2fd2e5e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd2e5e4",
  null
  
)

export default component.exports